<template>
  <div class="flex shuttle-container">
    <!-- 左侧 -->
    <div class="flex-column section">
      <div class="section-head">
        <slot name="left-head">
          <div class="flex">
            <el-checkbox v-model="isCheckedAll" @change="checkedAll">
              全选
            </el-checkbox>
          </div>
        </slot>
      </div>

      <div class="flex-1 section-main">
        <div class="section-main__in">
          <slot name="left-main">
            <div class="flex-column" style="height: 100%">
              <el-input
                v-if="isSearch"
                v-model="keyword"
                placeholder="请输入"
                size="small"
                clearable
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>

              <div class="flex-1" style="overflow-y: auto">
                <el-tree
                  ref="tree"
                  :data="treeData"
                  :node-key="nodeKey"
                  :props="treeProps"
                  show-checkbox
                  default-expand-all
                  check-on-click-node
                  :check-strictly="true"
                  :filter-node-method="filterNode"
                  v-bind="$attrs"
                  @check-change="handleCheckChange"
                  v-on="$listeners"
                >
                  <template slot-scope="{ node, data }">
                    <slot :node="node" :data="data">
                      <div
                        class="text-ellipsis"
                        :title="node.data[treeProps.label || 'name']"
                      >
                        {{ node.data[treeProps.label || 'name'] }}
                      </div>
                    </slot>
                  </template>
                </el-tree>
              </div>
            </div>
          </slot>
        </div>
      </div>
    </div>

    <!-- 中间 -->
    <div class="middle-section">
      <div
        class="flex flex-content right-arrow"
        :class="{ active: !!checkedCopyList.length }"
      >
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>

    <!-- 右侧 -->
    <div class="flex-column section">
      <div class="section-head">
        <slot name="right-head">
          已选&nbsp;&nbsp;{{ checkedCopyList.length || 0 }}&nbsp;&nbsp;项
        </slot>
      </div>
      <div class="flex-1 section-main">
        <div class="section-main__in">
          <slot name="right-main">
            <template v-if="checkedCopyList && checkedCopyList.length">
              <div
                v-for="(item, index) in checkedCopyList"
                :key="index"
                class="flex-align__between m-b-10"
              >
                <span class="flex-1 text-ellipsis">
                  {{ item[treeProps.label || 'name'] }}
                </span>
                <i
                  class="el-icon-delete m-l-20"
                  style="cursor: pointer"
                  @click="handleDel(item, index)"
                ></i>
              </div>
            </template>
            <template v-else>
              <div class="p-t-55 no-data">{{ emptyText }}</div>
            </template>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ShuttleContainer',

  props: {
    /**
     * 树数据
     */
    treeData: {
      type: Array,
      default: () => {
        return []
      },
    },
    /**
     * 树唯一标识
     */
    nodeKey: {
      type: String,
      default: 'id',
    },
    /**
     * 树配置选项
     */
    treeProps: {
      type: Object,
      default: () => {
        return { label: 'name', children: 'children' }
      },
    },
    /**
     * 是否需要搜索
     */
    isSearch: {
      type: Boolean,
      default: true,
    },
    /**
     * 默认选中列表: nodeKey唯一标识数组
     */
    checkedList: {
      type: Array,
      default: () => {
        return []
      },
    },

    /**
     * 右侧数据为空文字提示
     */
    emptyText: {
      type: String,
      default: '暂无数据'
    }
  },

  data() {
    return {
      // 是否全选
      isCheckedAll: false,
      // 关键字
      keyword: '',

      // 右侧已选
      checkedCopyList: []
    }
  },

  computed: {
    /**
     * 去除禁止选择的节点后的数组
     */
    usableArray() {
      return this.treeData.filter(item => !item[this.treeProps.disabled || 'disabled'])
    }
  },

  watch: {
    keyword(val) {
      this.$refs.tree.filter(val)
    },

    checkedList: {
      handler(val) {
        this.$nextTick(() => {
          // console.log('watch-checkedList', val)
          if (this.$refs) {
            this.$refs.tree.setCheckedKeys(val || [])
          }
        })
      },
      immediate: true
    },

    checkedCopyList: {
      handler(val) {
        // console.log('watch-checkedCopyList', val)
        this.$emit('checked', val)
      },
      deep: true
    }
  },

  methods: {
    /**
     * 数据初始化
     */
    initData() {
      this.isCheckedAll = false
      this.keyword = ''
      this.checkedCopyList = []
      this.$refs.tree.setCheckedNodes([])
    },
    /**
     * 全选
     * 目前只支持无嵌套层级树
     */
    checkedAll() {
      if (this.isCheckedAll) {
        this.$refs.tree.setCheckedNodes(this.usableArray)
      } else {
        this.$refs.tree.setCheckedNodes([])
      }
    },
    /**
     * 过滤分类数据
     */
    filterNode(value, data) {
      if (!value) return true
      return data[this.treeProps.label || 'name'].indexOf(value) !== -1
    },
    /**
     * 节点选中发生变化时
     */
    handleCheckChange(data, checked, indeterminate) {
      // console.log(data, checked, indeterminate)

      if (checked) {
        this.checkedCopyList.push(data)
      } else {
        this.checkedCopyList = this.checkedCopyList.filter(
          (item) => item[this.nodeKey] !== data[this.nodeKey]
        )
      }

      this.$nextTick(() => {
        this.isCheckedAll = (this.checkedCopyList.length === this.usableArray.length)
      })
    },
    /**
     * 删除
     */
    handleDel(item, index) {
      this.checkedCopyList.splice(index, 1)

      this.$refs.tree.setChecked(item[this.nodeKey], false)

      // this.isCheckedAll = false
    },
  },
}
</script>
<style scoped lang="scss">
.section {
  width: 240px;
  height: 320px;
  border: 1px solid $info-third-color;
  border-radius: 4px;

  &-head {
    padding: pixel-to-rem($n: 10) pixel-to-rem($n: 16);
    border-bottom: 1px solid $info-third-color;
  }

  &-main {
    padding: pixel-to-rem($n: 14) pixel-to-rem($n: 16);
    overflow: hidden;

    &__in {
      height: 100%;
      overflow-y: auto;
    }
  }
}

.middle-section {
  .right-arrow {
    width: pixel-to-rem($n: 36);
    height: pixel-to-rem($n: 28);
    margin: 0 pixel-to-rem($n: 20);
    background: $info-fourth-color;
    border: 1px solid $info-third-color;
    border-radius: 4px;
    color: $fourth-text-color;

    &.active {
      background: $primary-color;
      border-color: $primary-color;
      color: $white-color;
    }
  }
}

::v-deep {
  .el-tree {
    color: $text-color;
    margin-top: pixel-to-rem($n: 20);
  }
}

.no-data {
  color: $third-text-color;
  text-align: center;
}
</style>
